<div class="archive-page-container">
  <mat-card class="archive-header-card">
    <mat-card-header>
      <h2>Archived Activities</h2>
      <p class="subtitle">Manage and reuse archived activities</p>
    </mat-card-header>
  </mat-card>

  <mat-card class="archive-content-card">
    <mat-card-content>
      <div class="search-bar-container">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search archived activities</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search by name, type, or store">
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
      </div>

      @if (isLoading) {
        <div class="loading-container">
          <mat-spinner></mat-spinner>
        </div>
      } @else {
        @if (archivedActivities.length === 0) {
          <div class="no-activities">
            <mat-icon>archive</mat-icon>
            <p>No archived activities found</p>
          </div>
        } @else {
          <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort class="archived-activities-table">
              
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Activity Name</th>
                <td mat-cell *matCellDef="let activity">{{ activity.name }}</td>
              </ng-container>

              <!-- Type Column -->
              <ng-container matColumnDef="mainActivityType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let activity">{{ activity.mainActivityType || 'N/A' }}</td>
              </ng-container>

              <!-- Store Column -->
              <ng-container matColumnDef="store">
                <th mat-header-cell *matHeaderCellDef>Store</th>
                <td mat-cell *matCellDef="let activity">
                  <button mat-button color="primary" (click)="viewStore(activity)">
                    View Store
                  </button>
                </td>
              </ng-container>

              <!-- Duration Column -->
              <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef>Duration</th>
                <td mat-cell *matCellDef="let activity">{{ activity.duration || 'N/A' }}</td>
              </ng-container>

              <!-- Price Column -->
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                <td mat-cell *matCellDef="let activity">
                  {{ activity.currencyType || '' }} {{ activity.pricePerPerson || 0 }}
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let activity">
                  <button mat-raised-button color="primary" (click)="reuseActivity(activity)" class="action-button">
                    <mat-icon>add_circle</mat-icon>
                    Reuse
                  </button>
                  <button mat-raised-button color="accent" (click)="unarchiveActivity(activity)" class="action-button">
                    <mat-icon>unarchive</mat-icon>
                    Unarchive
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
          </div>
        }
      }
    </mat-card-content>
  </mat-card>
</div>


